'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _taggedTemplateLiteral = _interopDefault(require('@babel/runtime/helpers/taggedTemplateLiteral'));
var gql = _interopDefault(require('graphql-tag'));

var _templateObject;
var globalSettingsQuery = (function (globalSettingsRequested) {
  return gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query GetGlobalSettings(\n    $product: String!\n    $retailerMoniker: String!\n    $localeLanguage: Language\n    $localeCountry: Country\n  ) {\n    globalSettings(\n      product: $product\n      retailerMoniker: $retailerMoniker\n      localeLanguage: $localeLanguage\n      localeCountry: $localeCountry\n    ) {\n      ", "\n    }\n  }\n"])),
  // eslint-disable-next-line graphql/template-strings
  globalSettingsRequested);
});

exports.default = globalSettingsQuery;
